import axios, { isAxiosError } from "axios";

axios.defaults.withCredentials = true;
axios.defaults.paramsSerializer = { indexes: null };

axios.interceptors.request.use(
  (config) => {
    config.headers["X-CSRF"] = "1";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRedirecting = false;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && !isRedirecting) {
      isRedirecting = true;
      const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/bff/login?returnUrl=${returnUrl}`;
    }

    return Promise.reject(error);
  }
);

export interface ApiErrorResponse {
  code?: string;
  message?: string;
  error?: string;
}

export function getErrorMessage(err: unknown, fallback: string): string {
  if (isAxiosError<ApiErrorResponse>(err) && err.response?.data?.message) {
    return err.response.data.message;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return fallback;
}

export default axios;
